// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    import AwFlexRow from 'viewmodel/AwFlexRowViewModel';
import AwFlexColumn from 'viewmodel/AwFlexColumnViewModel';
import AwPanelSection from 'viewmodel/AwPanelSectionViewModel';
import AwPanelBody from 'viewmodel/AwPanelBodyViewModel';
import AwSplmTable from 'viewmodel/AwSplmTableViewModel';
    import { ExistWhen } from 'js/hocCollection';
const AwFlexRowExistWhen = ExistWhen(AwFlexRow);
AwFlexRowExistWhen.displayName = 'AwFlexRowExistWhen';

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/desCatalogEventBus', () => import('js/desCatalogEventBus'));
registerDynImportEntry('js/DesCatalogNavigationViewService', () => import('js/DesCatalogNavigationViewService'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "lifecycleHooks": {
        "onMount": "reveal",
        "onUpdate": [
            {
                "action": "resetContentPathOnUpdateOfProps",
                "observers": [
                    "props.accsessionid",
                    "props.catalogspaceid",
                    "props.locale",
                    "props.hideelements",
                    "props.filterStatus",
                    "props.contentpath",
                    "props.navigationtype",
                    "props.filterunit"
                ]
            },
            {
                "action": "customSelectionChangeAction",
                "observers": [
                    "viewModel.atomicData.selectionData"
                ]
            }
        ],
        "onUnmount": "executeCleanup"
    },
    "props": {
        "accsessionid": {
            "type": "STRING"
        },
        "catalogspaceid": {
            "type": "STRING"
        },
        "provider": {
            "type": "STRING"
        },
        "contentpath": {
            "type": "STRING"
        },
        "locale": {
            "type": "STRING"
        },
        "hideelements": {
            "type": "STRING"
        },
        "filterStatus": {
            "type": "string"
        },
        "crumb": {
            "type": "STRING"
        },
        "tablename": {
            "type": "STRING"
        },
        "expansionstate": {
            "type": "STRING"
        },
        "navigationtype": {
            "type": "STRING"
        },
        "filterunit": {
            "type": "STRING"
        }
    },
    "dataProviders": {
        "navigationTreeProvider": {
            "action": "loadData",
            "initializeAction": "loadData",
            "treeLoadResult": "{{data.treeLoadResult}}",
            "totalFound": "{{data.totalFound}}",
            "inputData": {
                "accessMode": "tree",
                "topNodeUid": "catalogFolder",
                "selectionData": "{{fields.selectionData}}"
            },
            "selectionModelmode": "none",
            "cacheCollapse": "TRUE"
        }
    },
    "data": {
        "providerLabel": {
            "displayName": "",
            "type": "STRING",
            "isRequired": "false",
            "isEditable": "false",
            "dbValue": "",
            "labelPosition": "NO_PROPERTY_LABEL",
            "dispValue": ""
        },
        "selectedNodeContentPath": "{{props.contentpath}}",
        "nodeBeingExpandedName": "",
        "isParent": false,
        "_constants": {
            "CATALOG_GROUP_SYSTEM_SECTION_HEADER": "section-header"
        },
        "pageSize": 50,
        "tableheader": "{{props.tablename}}",
        "tableId": "{{props.id}}",
        "filterStatus": "{{props.filterStatus}}",
        "selectionData": {
            "initialValues": {},
            "meta": {}
        }
    },
    "actions": {
        "reveal": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "conditionalCacheHandling"
                },
                {
                    "action": "resetSelectedNodeContentPath"
                },
                {
                    "action": "setProviderLabel"
                }
            ]
        },
        "loadData": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {
                            "accSessionId": "{{props.accsessionid}}",
                            "provider": "{{props.provider}}",
                            "parentNodeUid": "{{data.treeLoadInput.parentNode.uid}}",
                            "parentNodeLevelNdx": "{{data.treeLoadInput.parentNode.levelNdx}}",
                            "isParent": "{{data.data.isParent}}",
                            "nodeBeingExpandedName": "{{data.treeLoadInput.parentNode.uid}}"
                        },
                        "query": "query TreeNavigation ($treeNavigationInput: TreeNavigationInput) { treeNavigation (treeNavigationInput: $treeNavigationInput) }",
                        "variables": {
                            "treeNavigationInput": {
                                "catalogspaceId": "{{props.catalogspaceid}}",
                                "skip": "{{function:getSkip}}",
                                "limit": "{{data.pageSize}}",
                                "filter": "{{props.filterStatus}}",
                                "path": "{{function:getContentPath}}",
                                "type": "{{props.navigationtype}}",
                                "locale": "{{props.locale}}",
                                "filterUnit": "{{props.filterunit}}"
                            }
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accsessionid": "{{props.accsessionid}}"
            },
            "outputData": {
                "treeLoadResult": "{{function:loadTreeTableData}}"
            },
            "deps": "js/accHttpService"
        },
        "publishToACCEventBus": {
            "actionType": "JSFunction",
            "method": "publish",
            "inputData": {
                "eventId": "{{parameters.eventName}}",
                "eventData": "{{parameters.eventData}}"
            },
            "deps": "js/desCatalogEventBus"
        },
        "setProviderLabel": {
            "actionType": "JSFunction",
            "method": "setProviderLabel",
            "inputData": {
                "vmo": "{{data}}",
                "props": "{{props}}"
            },
            "deps": "js/DesCatalogNavigationViewService"
        },
        "conditionalCacheHandling": {
            "actionType": "JSFunction",
            "method": "conditionalCacheHandling",
            "inputData": {
                "props": "{{props}}"
            },
            "deps": "js/DesCatalogNavigationViewService"
        },
        "resetSelectedNodeContentPath": {
            "actionType": "JSFunction",
            "method": "resetSelectedNodeContentPath",
            "inputData": {
                "vmo": "{{data}}",
                "provider": "{{props.provider}}",
                "crumb": "{{props.crumb}}",
                "props": "{{props}}"
            },
            "deps": "js/DesCatalogNavigationViewService"
        },
        "setContentPath": {
            "actionType": "JSFunction",
            "method": "setContentPath",
            "inputData": {
                "vmo": "{{data}}",
                "selectedNodeData": "{{parameters.eventData}}"
            },
            "deps": "js/DesCatalogNavigationViewService"
        },
        "resetContentPathOnUpdateOfProps": {
            "actionType": "JSFunction",
            "method": "resetContentPathOnUpdateOfProps",
            "inputData": {
                "vmo": "{{data}}",
                "props": "{{props}}"
            },
            "deps": "js/DesCatalogNavigationViewService"
        },
        "loadColumns": {
            "actionType": "JSFunction",
            "method": "loadTreeMatrixColumns",
            "inputData": {
                "vmo": "{{data}}",
                "dataProvider": "{{data.dataProviders.navigationTreeProvider}}",
                "props": "{{props}}"
            },
            "deps": "js/DesCatalogNavigationViewService"
        },
        "autoSelectTreeNodeAsCrumbClicked": {
            "actionType": "JSFunction",
            "method": "autoSelectTreeNodeAsCrumbClicked",
            "inputData": {
                "vmo": "{{data}}",
                "crumbObj": "{{parameters.eventData}}"
            },
            "deps": "js/DesCatalogNavigationViewService"
        },
        "refreshTableAction": {
            "actionType": "Event",
            "method": "Event",
            "inputData": {
                "events": [
                    {
                        "name": "treeGrid.plTable.reload"
                    }
                ]
            }
        },
        "navigationTreeProviderSelectionChangeEvent": {
            "actionType": "Event",
            "method": "Event",
            "inputData": {
                "events": [
                    {
                        "name": "navigationTreeProviderSelectionChangeEvent",
                        "eventData": {
                            "eventName": "navigationTreeProviderSelectionChangeEvent",
                            "eventData": "{{parameters.eventData}}"
                        }
                    }
                ]
            }
        },
        "updateCrumbs": {
            "actionType": "Event",
            "method": "Event",
            "inputData": {
                "events": [
                    {
                        "name": "des-catalog-navigation.update-crumbs",
                        "eventData": {
                            "eventName": "des-catalog-navigation.update-crumbs"
                        }
                    }
                ]
            }
        },
        "performBatchActionForSelection": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "navigationTreeProviderSelectionChangeEvent",
                    "inputArgs": {
                        "eventName": "{{parameters.eventName}}",
                        "eventData": "{{parameters.eventData}}"
                    }
                }
            ]
        },
        "autoSelectTreeNodeAsCrumbClickedAndUpdateCrumbs": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "autoSelectTreeNodeAsCrumbClicked"
                },
                {
                    "action": "updateCrumbs"
                }
            ]
        },
        "customSelectionChangeAction": {
            "actionType": "JSFunction",
            "method": "customSelectionChangeHandler",
            "inputData": {
                "localSelectionData": "{{data.selectionData}}"
            },
            "deps": "js/DesCatalogNavigationViewService"
        },
        "executeCleanup": {
            "actionType": "JSFunction",
            "method": "executeCleanup",
            "deps": "js/DesCatalogNavigationViewService"
        }
    },
    "columnProviders": {
        "navigationColumnProvider": {
            "frozenColumnIndex": -1,
            "loadColumnAction": "loadColumns",
            "columns": "{{data.columns}}"
        }
    },
    "grids": {
        "treeGrid": {
            "dataProvider": "navigationTreeProvider",
            "columnProvider": "navigationColumnProvider",
            "addIconColumn": false,
            "gridOptions": {
                "enableGridMenu": false,
                "enablePinning": false,
                "enableSorting": false,
                "enableExpansionStateCaching": true
            }
        }
    },
    "functions": {
        "loadTreeTableData": {
            "functionName": "loadTreeTableData",
            "parameters": [
                "{{data.treeLoadInput.parentNode}}",
                "{{data.dataProviders.navigationTreeProvider}}",
                "{{data.pageSize}}"
            ],
            "deps": "js/DesCatalogNavigationViewService"
        },
        "getSkip": {
            "functionName": "getSkip",
            "parameters": [
                "{{data.treeLoadInput.parentNode}}",
                "{{data}}",
                "{{props}}"
            ],
            "deps": "js/DesCatalogNavigationViewService"
        },
        "getContentPath": {
            "functionName": "getContentPath",
            "parameters": [
                "{{data.treeLoadInput}}",
                "{{props}}"
            ],
            "deps": "js/DesCatalogNavigationViewService"
        }
    },
    "onEvent": [
        {
            "eventId": "navigationTreeProvider.selectionChangeEvent",
            "action": "performBatchActionForSelection",
            "inputArgs": {
                "eventName": "des-catalog-navigation.selectionChange",
                "eventData": "{{eventData.selectedObjects}}"
            }
        },
        {
            "eventId": "treeGrid.plTable.toggleTreeNode",
            "cacheEventData": true,
            "action": "setContentPath",
            "inputArgs": {
                "eventName": "treeGrid.plTable.toggleTreeNode",
                "eventData": "{{eventData}}"
            }
        },
        {
            "eventId": "des-refreshNavigationTable",
            "action": "refreshTableAction"
        },
        {
            "eventId": "des-breadcrumb.click.catalog",
            "action": "autoSelectTreeNodeAsCrumbClickedAndUpdateCrumbs",
            "cacheEventData": false,
            "inputArgs": {
                "eventData": "{{eventData.eventData}}"
            }
        }
    ],
    "messages": {},
    "i18n": {
        "catalogGroupSystem": [
            "DesCatalogPartSummaryMessages"
        ]
    },
    "conditions": {
        "hideGroupSystemPanelSectionHeader": {
            "expression": "props.hideelements && props.hideelements.split(',').indexOf(data._constants.CATALOG_GROUP_SYSTEM_SECTION_HEADER) > -1"
        }
    },
    "_viewModelId": "DesCatalogNavigation",
    "_uniqueViewModelId": "DesCatalogNavigation",
    "ctx": {}
};

    /*
    <aw-flex-row height="12" width="fill" class="afx-content-background">
    <aw-flex-column>
        <aw-flex-row height="fill" exist-when="!conditions.hideGroupSystemPanelSectionHeader">
            <aw-panel-section caption="i18n.catalogGroupSystem" class="des-navigation-content">
                <aw-panel-body>
                    <aw-splm-table gridid="treeGrid" use-tree="true" show-decorators="true"></aw-splm-table>
                </aw-panel-body>
            </aw-panel-section>
        </aw-flex-row>
        <aw-flex-row height="fill" exist-when="conditions.hideGroupSystemPanelSectionHeader">
            <aw-splm-table gridid="treeGrid" use-tree="true" show-decorators="true"></aw-splm-table>
        </aw-flex-row>
    </aw-flex-column>
</aw-flex-row>

    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
                <AwFlexRow height="12" width="fill" className="afx-content-background">
        <AwFlexColumn>
            <AwFlexRowExistWhen height="fill" existWhen={AwParseService.instance( "!conditions.hideGroupSystemPanelSectionHeader" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                <AwPanelSection caption={i18n.catalogGroupSystem} className="des-navigation-content">
                    <AwPanelBody>
                        <AwSplmTable {...grids.treeGrid} useTree={AwParseService.instance( "true" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} showDecorators={AwParseService.instance( "true" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                        </AwSplmTable>
                    </AwPanelBody>
                </AwPanelSection>
            </AwFlexRowExistWhen>
            <AwFlexRowExistWhen height="fill" existWhen={AwParseService.instance( "conditions.hideGroupSystemPanelSectionHeader" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                <AwSplmTable {...grids.treeGrid} useTree={AwParseService.instance( "true" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} showDecorators={AwParseService.instance( "true" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                </AwSplmTable>
            </AwFlexRowExistWhen>
        </AwFlexColumn>
    </AwFlexRow>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;